import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { DiagnosticsVddSelectionModalComponent } from '../diagnostics-vdd-selection-modal/diagnostics-vdd-selection-modal.component';
import { DiagnosticsUseCasesModalComponent } from '../diagnostics-use-cases-modal/diagnostics-use-cases-modal.component';

@Component({
  selector: 'app-extended-parameter-welcome-screen',
  templateUrl: './extended-parameter-welcome-screen.component.html',
  styleUrls: ['./extended-parameter-welcome-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtendedParameterWelcomeScreenComponent {
  @Input() useCasesSelected: boolean;

  constructor(private dialog: MatDialog) {}

  openModal(): void {
    if (this.useCasesSelected) {
      this.dialog.open(DiagnosticsUseCasesModalComponent, {
        width: '424px',
      });
    } else {
      this.dialog.open(DiagnosticsVddSelectionModalComponent, {
        width: '424px',
        disableClose: true,
      });
    }
  }
}
